import React from "react";
import "react-step-progress-bar/styles.css";
import "../css/MultiStepProgressBar.css";

const { ProgressBar, Step } = require("react-step-progress-bar");
const MultiStepProgressBar = (props: any) => {
  // Calculate percent so that last step shows 100%
  // For N steps: step 0 = 0%, step N-1 = 100%
  let percent =
    props.steps.length > 1
      ? (props.currentStepIndex / (props.steps.length - 1)) * 100
      : 100;

  const safePercent = Math.min(100, Math.max(0, isNaN(percent) ? 0 : percent));

 // console.log("typeof percent:", typeof safePercent, "value:", safePercent);

  return (
    <div
      style={{
        overflowX: "auto",
        overflowY: "clip",
        paddingBottom: "15px",
        paddingTop: "15px",
      }}
    >
      <div
        style={{
          minWidth: `${Math.max(props.steps.length * 45, 300)}px`,
          paddingLeft: "15px",
          paddingRight: "15px",
        }}
      >
        <ProgressBar
          // percent={((props.currentStepIndex) * 100) / props.steps.length}

          percent={+safePercent}
          // percent={30}

          filledBackground="green"
        >
          {props.steps.length ? (
            <>
              {Array.from({ length: props.steps.length }).map(
                (element, indexmap) => (
                  <Step transition="scale" key={indexmap}>
                    {({ accomplished, index }: any) => (
                      <div
                        className={`indexedStep ${
                          indexmap == props.currentStepIndex
                            ? "accomplished"
                            : null
                        }`}
                        onClick={() => {
                          props.goTo(indexmap);
                        }}
                        style={{ cursor: "pointer", fontSize: "20px" }}
                      >
                        {indexmap + 1}
                      </div>
                    )}
                  </Step>
                )
              )}
            </>
          ) : null}
        </ProgressBar>
      </div>
    </div>
  );
};
export default MultiStepProgressBar;
